/* global axios */
import ApiClient from './ApiClient';

class CommercialImportsAPI extends ApiClient {
  constructor() {
    super('commercial_import', { accountScoped: true });
  }

  preview(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/preview`, formData);
  }

  importData({ blobId, mapping, dryRun }) {
    return axios.post(this.url, {
      blob_id: blobId,
      mapping,
      dry_run: dryRun,
    });
  }
}

export default new CommercialImportsAPI();
